import { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import SignIn from './Components/SignIn/SignIn';
import SignUp from './Components/SignUp/SignUp';
import ForgotPassword from './Components/ForgotPassword/ForgotPassword';
import Courier from './Components/Courier/Courier';
import { Route, Routes, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie'; // Importing js-cookie library

// Conditional redirect component
const RedirectIfLoggedIn = ({ children, redirectUrl }) => {
  // Check if the user is logged in by reading cookies
  const isLoggedIn = Cookies.get('userEmail') && Cookies.get('userToken');

  if (isLoggedIn) {
    // If logged in, redirect to the given URL (external)
    window.location.href = redirectUrl;
    return null;
  }

  return children; // If not logged in, show the children (component)
};

function App() {

  
  const [userEmail, setUserEmail] = useState(null);
  const [userToken, setUserToken] = useState(null);
  const location = useLocation(); // To access the URL location


  useEffect(() => {

    const urlParams = new URLSearchParams(location.search);
    const action = urlParams.get('action');

    if (action === 'logout') {
      // Clear cookies when logout action is triggered
      Cookies.remove('userEmail');
      Cookies.remove('userToken');
      Cookies.remove('timestamp');
      console.log('Logged out and cookies cleared.');

      // Optionally, redirect the user to the login page after logout
      window.location.href = '/';
    } else {
      // Proceed with setting up the user state if cookies exist
      const storedUserEmail = Cookies.get('userEmail');
      const storedUserToken = Cookies.get('userToken');
      const storedTimestamp = Cookies.get('timestamp');

      const currentTimestamp = new Date().getTime();
      const expiryTime = 5 * 24 * 60 * 60 * 1000; // 1 day expiration

      if (storedTimestamp && (currentTimestamp - parseInt(storedTimestamp) > expiryTime)) {
        // Clear cookies if expired
        Cookies.remove('userEmail');
        Cookies.remove('userToken');
        Cookies.remove('timestamp');
        console.log('Cookies cleared due to expiration.');
      } else if (storedUserEmail && storedUserToken) {
        setUserEmail(storedUserEmail);
        setUserToken(storedUserToken);
      }
    }
  }, [location.search]);

  // Set redirect URL
  const redirectUrl = `https://apps.lateshipment.com/dashboard?lsemail=${userEmail}&lstoken=${userToken}`;

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <RedirectIfLoggedIn redirectUrl={redirectUrl}>
              <SignIn />
            </RedirectIfLoggedIn>
          }
        />

        <Route
          path="/login"
          element={
            <RedirectIfLoggedIn redirectUrl={redirectUrl}>
              <SignIn />
            </RedirectIfLoggedIn>
          }
        />

        <Route
          path="/signup"
          element={
            <RedirectIfLoggedIn redirectUrl={redirectUrl}>
              <SignUp />
            </RedirectIfLoggedIn>
          }
        />

        {/* Reset password page is accessible regardless of login status */}
        <Route path="/resetpassword" element={<ForgotPassword />} />

        <Route
          path="/courier"
          element={
            <RedirectIfLoggedIn redirectUrl={redirectUrl}>
              <Courier />
            </RedirectIfLoggedIn>
          }
        />
      </Routes>
    </div>
  );
}

export default App;



// import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import SignIn from './Components/SignIn/SignIn';
// import SignUp from './Components/SignUp/SignUp';
// import ForgotPassword from './Components/ForgotPassword/ForgotPassword';
// import Courier from './Components/Courier/Courier';
// import { Route, Routes, Navigate } from 'react-router-dom';


// function App() {


//   return (
//     <div className="App">
//       <Routes>
//         <Route
//           path="/"
//           element={
//             <SignIn />
//           }
//         />

//         <Route
//           path="/signup"
//           element={
//             <SignUp />
//           }
//         />

//         {/* Reset password page is accessible regardless of login status */}
//         <Route path="/resetpassword" element={<ForgotPassword />} />

//         <Route
//           path="/courier"
//           element={
//             <Courier />
//           }
//         />
//       </Routes>
//     </div>
//   );
// }

// export default App;
